import {IDeviceCoordinatesDto} from "./Dto/IDeviceCoordinatesDto";
import RepositoryWorker from "../RepositoryWorker";
import {IDevicePacketsDto} from "./Dto/IDevicePacketsDto";
import {IDeviceStatusesDto} from "./Dto/IDeviceStatusesDto";
import {DateTimeFormatter} from "../../utils/DateTimeFormatter";
import {AxiosRequestConfig} from 'axios';

class DeviceRepository {

    static getCoordinatesByDeviceIdList(deviceIdList: number[], config?: AxiosRequestConfig): Promise<IDeviceCoordinatesDto[]> {
        if (config) {
            return RepositoryWorker.makePostCallInternal('/api/v1/devices/coordinates', {deviceList: deviceIdList}, config);
        }
        return RepositoryWorker
            .makePostCallInternal(
                '/api/v1/devices/coordinates',
                {
                    deviceList: deviceIdList,
                });
    }

    static getFullCoordinatesByDeviceId(deviceId: number, config?: AxiosRequestConfig): Promise<IDeviceStatusesDto> {
        if (config) {
            return RepositoryWorker.makeGetCallInternal(`/api/v1/devices/${deviceId}/coordinates`, undefined, config);
        }
        return RepositoryWorker
            .makeGetCallInternal(
                `/api/v1/devices/${deviceId}/coordinates`
            );
    }

    static getPacketsForDevice(deviceId: number, from: Date|number, to: Date|number): Promise<IDevicePacketsDto> {
        return RepositoryWorker
            .makeGetCallInternal(`/api/v1/devices/${deviceId}/packets`,
                [
                    { name: 'from', value: DateTimeFormatter.toYYYYMMDDHHMMSS(from) },
                    { name: 'to', value: DateTimeFormatter.toYYYYMMDDHHMMSS(to) }
                ]);
    }

    static getPacketsCoordinatesByDeviceId(deviceId: number, from: Date|number, to: Date|number): Promise<IDevicePacketsDto> {
        return RepositoryWorker
            .makeGetCallInternal(`api/v1/devices/${deviceId}/packets/coordinates`,
                [
                    { name: 'from', value: DateTimeFormatter.toYYYYMMDDHHMMSS(from) },
                    { name: 'to', value: DateTimeFormatter.toYYYYMMDDHHMMSS(to) }
                ]);

    }
}

export default DeviceRepository;
